export default __webpack_public_path__ + "static/media/comment.cfdd4451.svg";